const createStyleSheet = (id, url) => {
    var link = document.createElement('link');
    link.id = id;
    link.rel = 'stylesheet';
    link.type = 'text/css';
    link.href = url;
    link.setAttribute('disabled', '');
    document.head.appendChild(link);
};

createStyleSheet('vendor-css', System.resolve('bluedolphin/css-vendor'));
createStyleSheet('bluedolphin-css', System.resolve('bluedolphin/css-bluedolphin'));
